export const dummyProducts = [
	{
		"postTitle": { "titleText": "Sweatshirt" },
		"postId": { "id": 301 },
		"postDate": { "date": "10/10/2025" },
		"postAuthor": { "authorName": "FluentCart Store" },
		"commentsCount": { "count": 15 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/pickplugins-product-slider-for-fluentcart/wp-content/uploads/sites/9/2025/10/sweatshirt-3.jpeg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar1.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Pure organic honey collected from natural hives. Perfect for tea, desserts, and healthy recipes." }
	},
	{
		"postTitle": { "titleText": "Fleece jacket" },
		"postId": { "id": 302 },
		"postDate": { "date": "10/10/2025" },
		"postAuthor": { "authorName": "FluentCart Store" },
		"commentsCount": { "count": 22 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/pickplugins-product-slider-for-fluentcart/wp-content/uploads/sites/9/2025/10/fleece-jacket-3.jpeg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar2.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "A timeless denim jacket designed for comfort and style, ideal for casual wear all year round." }
	},
	{
		"postTitle": { "titleText": "Aesthetic Zipper Hoodie" },
		"postId": { "id": 303 },
		"postDate": { "date": "10/10/2025" },
		"postAuthor": { "authorName": "FluentCart Store" },
		"commentsCount": { "count": 10 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/pickplugins-product-slider-for-fluentcart/wp-content/uploads/sites/9/2025/10/aesthetic-zipper-hoodie-1-1.jpeg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar3.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Premium Italian fusilli pasta made from 100% durum wheat for a delicious and authentic taste." }
	},
	{
		"postTitle": { "titleText": "Mans Cap" },
		"postId": { "id": 304 },
		"postDate": { "date": "10/10/2025" },
		"postAuthor": { "authorName": "FluentCart Store" },
		"commentsCount": { "count": 30 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/pickplugins-product-slider-for-fluentcart/wp-content/uploads/sites/9/2025/10/men-hoodie-4.jpeg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar4.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Soft and breathable 100% cotton T-shirt in navy blue. Perfect for daily casual wear." }
	},
	{
		"postTitle": { "titleText": "Sweatshirt Hoodie" },
		"postId": { "id": 305 },
		"postDate": { "date": "10/10/2025" },
		"postAuthor": { "authorName": "FluentCart Store" },
		"commentsCount": { "count": 17 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/pickplugins-product-slider-for-fluentcart/wp-content/uploads/sites/9/2025/10/sweatshirt-hoodie-2.jpeg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar5.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Handcrafted brown leather wallet with multiple card slots and a sleek minimalist design." }
	},
	{
		"postTitle": { "titleText": "Modern Sweatshirt" },
		"postId": { "id": 306 },
		"postDate": { "date": "10/10/2025" },
		"postAuthor": { "authorName": "FluentCart Store" },
		"commentsCount": { "count": 12 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/pickplugins-product-slider-for-fluentcart/wp-content/uploads/sites/9/2025/10/modern-sweatshirt-2.jpeg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar6.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Smooth almond butter made from roasted almonds with no added sugar or preservatives." }
	},
	{
		"postTitle": { "titleText": "Hoodie Mans" },
		"postId": { "id": 307 },
		"postDate": { "date": "10/10/2025" },
		"postAuthor": { "authorName": "FluentCart Store" },
		"commentsCount": { "count": 28 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/pickplugins-product-slider-for-fluentcart/wp-content/uploads/sites/9/2025/10/hoodie-mans-4.jpeg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar7.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Lightweight floral dress with soft fabric, perfect for warm summer days and outdoor gatherings." }
	},
	{
		"postTitle": { "titleText": "Men Tshirt" },
		"postId": { "id": 308 },
		"postDate": { "date": "10/10/2025" },
		"postAuthor": { "authorName": "FluentCart Store" },
		"commentsCount": { "count": 8 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/pickplugins-product-slider-for-fluentcart/wp-content/uploads/sites/9/2025/10/men-t-shirt-4.jpeg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Long-grain premium basmati rice ideal for biryani, fried rice, and everyday cooking." }
	},

]
